import styled, { css } from 'styled-components';
import { mobile_xl } from '../../../global/mediaQueryMixin';

const MainMenu = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding-inline: var(--space-12);
  ${mobile_xl(css`
    gap: var(--space-4);
  `)}
`;

export { MainMenu };
